import React, { useState } from 'react';
import { Box, FormHelperText } from '@mui/material';
import { FieldWrapperVertical } from '@ui-framework/index';
import ServiceProviderRecommendedLocations from '@product-framework/components/FormFields/ServiceProviderRecommendedLocations';

export default function AcceptanceLocationFormSection({
  dispatchEventId,
  dispatchId,
  errors,
  serviceJobId,
  name,
}) {
  const error = errors?.acceptanceLocation;
  const [showLocationLabel, setShowLocationLabel] = useState(true);

  return (
    <Box sx={{ mb: 2 }}>
      <FieldWrapperVertical
        field={{
          name,
          label: {
            localeId: 'SERVICE_PROVIDER_LOCATION_LABEL',
            defaultMessage: 'Location',
          },
          required: true,
        }}
        errors={errors}
        noLabels={!showLocationLabel}>
        <ServiceProviderRecommendedLocations
          field={{
            name,
            dispatchEventId,
            dispatchId,
            serviceJobId,
          }}
          inPopUp
          onLocationsAvailabilityChange={setShowLocationLabel}
        />
        {error ? (
          <FormHelperText sx={{ typography: 'body2' }} error={Boolean(error)}>
            {error?.message}
          </FormHelperText>
        ) : null}
      </FieldWrapperVertical>
    </Box>
  );
}
